import type { AutocompleteResult } from '../../features/inventory/models/inventory.model';

export const resolveSearchNavigationCommands = (result: AutocompleteResult): string[] => {
  if (result.type === 'unit') {
    return ['/catalog', result.productId, 'variant', result.variantId, 'unit', result.unitId, 'edit'];
  }

  if (result.type === 'variant') {
    return ['/catalog', result.productId, 'variant', result.variantId, 'edit'];
  }

  return ['/catalog', result.productId, 'edit'];
};
